import * as _ from 'underscore';
import {EventEmitter, Injectable} from '@angular/core';
import 'rxjs/Rx';
import {ConfigResponse, PollResponse, TakerAppState} from '../../models';
import {LoggerService} from '../logger.service';
import {VariablesDesc} from '../../../../author/constants/type.constants';

@Injectable()
export class AppStateService {

    private event: EventEmitter<TakerAppState> = new EventEmitter<TakerAppState>(true);
    private configEvent: EventEmitter<ConfigResponse> = new EventEmitter<ConfigResponse>(true);

    private lastAppState: TakerAppState;
    private configResponse: ConfigResponse;             // received from config.json

    constructor(private logger: LoggerService) {
    }

    emit(appState: TakerAppState) {

        this.logger.log('AppStateService: emit', appState);

        this.event.emit(appState);

        if (appState.state === 'config') {
            this.configEvent.emit(this.configResponse);
        }

        this.lastAppState = appState;

    }

    subscribe(callback: any) {

        // this.logger.log('AppStateService: subscribe', callback);

        return this.event.subscribe((appState: TakerAppState) => callback(appState));
    }

    /**
     * Subscribe for ConfigResponse only.
     * If ConfigResponse is available invoke callback to provide it
     * @param callback
     * @returns {any}
     */
    subscribeConfig(callback: any) {

        // this.logger.log('AppStateService: subscribeConfig', callback);

        const ret = this.configEvent.subscribe((configResponse: ConfigResponse) => callback(configResponse));
        if (this.configResponse) {
            // provide ConfigResponse if already available
            callback(this.configResponse);
        }
        return ret;
    }

    getLastAppState(): TakerAppState {

        return this.lastAppState;
    }

    getPollLocalStartTime(): number {

        return this.lastAppState && this.lastAppState.context ? this.lastAppState.context.pollLocalStartTime : null;
    }

    getConfig(): ConfigResponse {
        return this.configResponse;
    }

    setConfig(config: ConfigResponse) {
        this.configResponse = config;
        if (this.configResponse && this.configResponse.vars) {
            this.massageVars(this.configResponse.vars);
        }
    }

    // Direct assignment without triggering event
    setPollResponse(pollResponse: PollResponse) {
        this.lastAppState.context.pollResponse = pollResponse;
    }

    /**
     * replacing null or undefined variable values with '' for rendering
     * @param vars
     * @private
     */
    private massageVars(vars: any): void {
        if (vars) {
            _.each(VariablesDesc, function (variableDesc: any) {
                if (vars[variableDesc.value] == null) {
                    vars[variableDesc.value] = '';
                }
            });
        }
    }

}
